import React from "react";
import ButtonOrang from "./ButtonOrang";
import flex from "../assets/images/sidom/fotos/FlechaenCirc3.png";

export default function CardTestimoMarcas({
  title,
  title2,
  description,
  buttonText,
  url,
}) {
  return (
    <div className="p-6   h-[400px] w-full sm:w-[350px]  flex flex-col justify-center  items-center   rounded-lg shadow-md transition-colors duration-300 bg-sidom-orange text-sidom-light dark:bg-sidom-orange ">
      <div className="flex  flex-col justify-center items-center min-w-[320px]   gap-[20px]">
        <div className=" w-full">
          <div className="flex flex-row h-full   justify-start gap-4 items-center ">
            <div className="flex items-start h-full  justify-start ">
              <img src={flex} alt="Logo Toyota" className=" w-8" />
            </div>

            {/* <img src={flex2} alt="Logo Toyota" className=" w-8" /> */}
            <div className="  ">
              {" "}
              <h1 className="text-2xl text-wrap  font-bold ">{title}</h1>
            </div>
          </div>
        </div>

        <div className="  w-full flex flex-col justify-center items-center">
          <div className="flex  flex-col justify-center pl-11   items-center ">
            <h1 className="text-2xl  font-bold mb-[20px]  pr-auto text-wrap    ">
              {title2}
            </h1>
            <p className="mb-[20px] border border-sidom-orange line-clamp-3 h-[100px] overflow-hidden text-ellipsis ">
              {description}
            </p>
            <div className="flex w-full justify-start items-center">
              <ButtonOrang
                text={buttonText}
                background="bg-sidom-blue"
                bloke={false}
                link={url}
                target="_blank"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
